// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2addde7e","667":"97c41aa4"}[chunkId] + ".chunk.js";
};